<template>
  <nav class="navigation-row">
    <div class="navigation-menu-box">
      <router-link
        :to="{
          name: 'PoliciesView',
        }"
        class="navigation-menu-box-logo">
        <img
          v-if="
            window.userData &&
            window.userData.tenant &&
            window.userData.tenant.logo &&
            window.userData.tenant.logo?.file_data
          "
          :src="window.userData.tenant.logo.file_data.toString()" />
        <img
          v-else-if="
            window.userData &&
            window.userData.tenant &&
            window.userData.tenant.icon &&
            window.userData.tenant.icon?.file_data
          "
          :src="window.userData.tenant.icon.file_data.toString()" />
        <img src="@/assets/logo.svg" v-else />
      </router-link>
      <div class="navigation-component-box-links">
        <router-link
          :to="{
            name: 'PoliciesView',
          }"
          :class="{
            'active-navigation-list-item': includesName($route.name, 'Policies') || includesName($route.name, 'Policy'),
          }"
          class="list-text-bold disabled-text">
          Полиси
        </router-link>
        <router-link
          :to="{
            name: 'InsureesView',
          }"
          :class="{
            'active-navigation-list-item': includesName($route.name, 'Insuree'),
          }"
          class="list-text-bold disabled-text">
          Осигуреници
        </router-link>

        <router-link
          :to="{
            name: 'DataAdder',
          }"
          :class="{
            'active-navigation-list-item': includesName($route.name, 'DataAdder'),
          }"
          class="list-text-bold disabled-text">
          Менаџирање со податоци
        </router-link>
        <router-link
          :to="{
            name: 'FAQsManagement',
          }"
          :class="{
            'active-navigation-list-item': includesName($route.name, 'FAQsManagement'),
          }"
          class="list-text-bold disabled-text">
          ЧПП
        </router-link>
        <router-link
          :to="{
            name: 'ContactDetailsManagement',
          }"
          :class="{
            'active-navigation-list-item': includesName($route.name, 'ContactDetailsManagement'),
          }"
          class="list-text-bold disabled-text">
          Контакт детали
        </router-link>

        <router-link
          :to="{
            name: 'StatisticsView',
          }"
          :class="{
            'active-navigation-list-item': includesName($route.name, 'StatisticsView'),
          }"
          class="list-text-bold disabled-text">
          Статистика
        </router-link>
      </div>
    </div>
    <div
      class="hamburger"
      @click="navigationOpened = true"
      :class="{
        'hamburger-menu-opened': navigationOpened,
      }">
      <div class="block"></div>
      <div class="block"></div>
      <div class="block"></div>
    </div>
    <Transition name="navigation-component-hamburger-list-animation">
      <div
        v-if="navigationOpened"
        class="navigation-component-hamburger-list"
        v-click-outside="
          () => {
            navigationOpened = false;
          }
        ">
        <div class="navigation-component-hamburger-list-options">
          <router-link
            @click="navigationOpened = false"
            :to="{
              name: 'ClientSelection',
            }"
            :class="{
              'active-navigation-list-item': includesName($route.name, 'ClientSelection'),
            }"
            class="navigation-component-hamburger-list-options-option list-text-bold disabled-text">
            Селектор на клиенти
          </router-link>
          <router-link
            @click="navigationOpened = false"
            :to="{
              name: 'PoliciesView',
            }"
            :class="{
              'active-navigation-list-item':
                includesName($route.name, 'Policies') || includesName($route.name, 'Policy'),
            }"
            class="navigation-component-hamburger-list-options-option navigation-component-hamburger-list-options-option-desktop list-text-bold disabled-text">
            Полиси
          </router-link>

          <router-link
            @click="navigationOpened = false"
            :to="{
              name: 'InsureesView',
            }"
            :class="{
              'active-navigation-list-item': includesName($route.name, 'Insuree'),
            }"
            class="navigation-component-hamburger-list-options-option navigation-component-hamburger-list-options-option-desktop list-text-bold disabled-text">
            Осигуреници
          </router-link>

          <router-link
            @click="navigationOpened = false"
            :to="{
              name: 'DataAdder',
            }"
            :class="{
              'active-navigation-list-item': includesName($route.name, 'DataAdder'),
            }"
            class="navigation-component-hamburger-list-options-option navigation-component-hamburger-list-options-option-desktop list-text-bold disabled-text">
            Менаџирање со податоци
          </router-link>
          <router-link
            @click="navigationOpened = false"
            :to="{
              name: 'FAQsManagement',
            }"
            :class="{
              'active-navigation-list-item': includesName($route.name, 'FAQsManagement'),
            }"
            class="navigation-component-hamburger-list-options-option navigation-component-hamburger-list-options-option-desktop list-text-bold disabled-text">
            ЧПП
          </router-link>
          <router-link
            @click="navigationOpened = false"
            :to="{
              name: 'ContactDetailsManagement',
            }"
            :class="{
              'active-navigation-list-item': includesName($route.name, 'ContactDetailsManagement'),
            }"
            class="navigation-component-hamburger-list-options-option navigation-component-hamburger-list-options-option-desktop list-text-bold disabled-text">
            Контакт детали
          </router-link>
          <router-link
            @click="navigationOpened = false"
            :to="{
              name: 'StatisticsView',
            }"
            :class="{
              'active-navigation-list-item': includesName($route.name, 'StatisticsView'),
            }"
            class="navigation-component-hamburger-list-options-option navigation-component-hamburger-list-options-option-desktop list-text-bold disabled-text">
            Статистика
          </router-link>
          <router-link
            @click="navigationOpened = false"
            :to="{
              name: 'ProfileView',
            }"
            :class="{
              'active-navigation-list-item': includesName($route.name, 'Profile'),
            }"
            class="navigation-component-hamburger-list-options-option list-text-bold disabled-text">
            Профил
          </router-link>
          <router-link
            @click="navigationOpened = false"
            :to="{
              name: 'UsersView',
            }"
            :class="{
              'active-navigation-list-item': includesName($route.name, 'User'),
            }"
            v-if="window.userData && window.userData.scopes.includes('user-management')"
            class="navigation-component-hamburger-list-options-option list-text-bold disabled-text">
            Корисници
          </router-link>
          <router-link
            @click="navigationOpened = false"
            :to="{
              name: 'ActivityLogsView',
            }"
            :class="{
              'active-navigation-list-item': includesName($route.name, 'ActivityLogsView'),
            }"
            v-if="window.userData && window.userData.scopes.includes('system-administrator')"
            class="navigation-component-hamburger-list-options-option list-text-bold disabled-text">
            Активности
          </router-link>
          <router-link
            v-if="window.userData && window.userData.scopes.includes('system-administrator')"
            @click="navigationOpened = false"
            :to="{
              name: 'ClientsView',
            }"
            :class="{
              'active-navigation-list-item': includesName($route.name, 'Clients'),
            }"
            class="navigation-component-hamburger-list-options-option list-text-bold disabled-text">
            Клиенти
          </router-link>

          <router-link
            v-if="window.userData && window.userData.scopes.includes('system-administrator')"
            @click="navigationOpened = false"
            :to="{
              name: 'ScopesManagement',
            }"
            :class="{
              'active-navigation-list-item': includesName($route.name, 'ScopesManagement'),
            }"
            class="navigation-component-hamburger-list-options-option list-text-bold disabled-text">
            Привилегии
          </router-link>
          <router-link
            v-if="window.userData && window.userData.scopes.includes('system-administrator')"
            @click="navigationOpened = false"
            :to="{
              name: 'LogsView',
            }"
            class="navigation-component-hamburger-list-options-option list-text-bold disabled-text">
            Логови
          </router-link>

          <a
            href="https://cdn.triglav.vortec.io/manuals/dzo_manual.pdf"
            target="_blank"
            class="navigation-component-hamburger-list-options-option list-text-bold disabled-text">
            Упатство за администратори
          </a>
          <a
            href="https://cdn.triglav.vortec.io/manuals/dzo_manual_client.pdf"
            target="_blank"
            class="navigation-component-hamburger-list-options-option list-text-bold disabled-text">
            Упатство за клиенти
          </a>

          <div
            class="navigation-component-hamburger-list-options-option navigation-component-hamburger-list-options-option-logout list-text-bold disabled-text"
            @click="logOutUser">
            Одјави се
            <div v-html="icons.logoutIcon"></div>
          </div>
          <div class="navigation-component-hamburger-list-options-option-footer">
            <p class="info-text upper-case-text center-text">
              © {{ new Date().getFullYear() }} Vortec | Сите права се задржани
            </p>
            <p class="info-text upper-case-text center-text">
              Изработено од <a href="https://vortec.io" class="vortec-text upper-case-text info-text-bold">Vortec</a>
            </p>
          </div>
        </div>
      </div>
    </Transition>
  </nav>
</template>

<script setup lang="ts">
import axios from 'axios';
import router from '@/router';
import { RouteRecordName } from 'vue-router';
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useDebounceFunc } from 'vortec-components-front';
import icons from '@/icons';

const navigationOpened = ref(false);

function includesName(outter: RouteRecordName | null | undefined, inner: string) {
  if (!outter) return false;
  const outterString = outter.toString();
  return outterString.includes(inner);
}

function logOutUser() {
  axios.post('/api/logout').then(() => {
    window.userData = null;
    router.push({ name: 'LoginPage' });
  });
}

const previousScrollY = ref(0);

let navigationElement: HTMLElement | null = null;
let tableRowElement: HTMLElement | null = null;
let subNavigation: HTMLElement | null = null;
let table: HTMLElement | null = null;

const cacheElements = () => {
  navigationElement = document.querySelector('.navigation-row');
  tableRowElement = document.querySelector('.table-row-header-movement');
  subNavigation = document.querySelector('.sub-navigation-row-movable');
  table = document.querySelector('.table') || document.querySelector('.grid-table');
};

const handleScroll = () => {
  cacheElements();
  if (!navigationElement) {
    return;
  }

  const scrollY = window.scrollY;
  const isScrollingUp = scrollY < previousScrollY.value;
  const headerHeight = navigationElement.clientHeight;
  const applyTransition = (element: HTMLElement, duration = '0.2s') => {
    element.style.transition = `transform ${duration}`;
  };

  const computedPosition = window.getComputedStyle(navigationElement).position;

  if (scrollY > headerHeight) {
    if (computedPosition !== 'sticky') {
      setTimeout(() => {
        if (!navigationElement) cacheElements();
        if (navigationElement) {
          navigationElement.style.position = 'sticky';
          applyTransition(navigationElement);
        }
      }, 200);
    }
    if (isScrollingUp) {
      navigationElement.style.transform = 'translateY(0)';
      applyTransition(navigationElement);
    } else {
      navigationElement.style.transform = 'translateY(-100%)';
      applyTransition(navigationElement);
    }
  } else if (scrollY <= 1) {
    navigationElement.style.position = 'relative';
    navigationElement.style.transition = 'none';
    navigationElement.style.transform = 'translateY(0)';
  }

  if (subNavigation) {
    const subNavigationHeight = subNavigation.clientHeight;
    const computedPosition = window.getComputedStyle(subNavigation).position;

    if (scrollY > headerHeight + subNavigationHeight) {
      if (computedPosition !== 'sticky') {
        setTimeout(() => {
          if (subNavigation) {
            subNavigation.style.position = 'sticky';
            applyTransition(subNavigation);
          }
        }, 200);
      }
      if (isScrollingUp) {
        subNavigation.style.transform = `translateY(${headerHeight}px)`;
      } else {
        subNavigation.style.transform = `translateY(-200%)`;
        subNavigation.style.transition = 'none';
      }
      applyTransition(subNavigation);
    } else if (scrollY >= headerHeight && scrollY <= headerHeight + subNavigationHeight) {
      if (isScrollingUp) {
        subNavigation.style.position = 'sticky';
        subNavigation.style.transform = `translateY(${subNavigationHeight}px)`;
      } else {
        subNavigation.style.transform = `translateY(-200%)`;
        subNavigation.style.transition = 'none';
      }
      applyTransition(subNavigation);
    } else if (scrollY <= headerHeight) {
      if (scrollY <= 1) {
        subNavigation.style.position = 'relative';
        subNavigation.style.transform = `translateY(0px)`;
        subNavigation.style.transition = 'none';
      } else if (computedPosition === 'sticky' && isScrollingUp) {
        subNavigation.style.position = 'sticky';
        subNavigation.style.transform = `translateY(${scrollY}px)`;

        applyTransition(subNavigation);
      }
    }
  }

  if (tableRowElement) {
    const topHeight = navigationElement.clientHeight + (subNavigation ? subNavigation.clientHeight : 0);
    let desiredTranslate = 0;

    if (isScrollingUp) {
      if (table) {
        const tableTop = table.getBoundingClientRect().top;
        if (tableTop > 0) {
          desiredTranslate = Math.max(0, topHeight - tableTop);
        } else {
          desiredTranslate = topHeight;
        }
      }
      tableRowElement.style.transform = `translateY(${desiredTranslate}px)`;

      applyTransition(tableRowElement);
    } else {
      tableRowElement.style.transform = 'translateY(0)';
      tableRowElement.style.transition = 'none';
    }

    if (desiredTranslate === 0) {
      tableRowElement.classList.remove('box-shadow-bottom');
    } else if (!tableRowElement.classList.contains('box-shadow-bottom')) {
      tableRowElement.classList.add('box-shadow-bottom');
    }
  }

  previousScrollY.value = scrollY;
};

onMounted(() => {
  window.addEventListener('scroll', useDebounceFunc(handleScroll, 25), { passive: true });
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>
